var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailCopy = function SvgEmailCopy(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-20": 17,
    "data-width-24": 20,
    viewBox: "0 0 13.6 11.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.022 0a1.5 1.5 0 0 1 1.5 1.5v6.333a1.5 1.5 0 0 1-1.5 1.5H3.354a1.5 1.5 0 0 1-1.5-1.5V1.5a1.5 1.5 0 0 1 1.5-1.5zM7.975 5.406a.5.5 0 0 1-.287.094.5.5 0 0 1-.287-.094L2.854 2.18v5.653a.507.507 0 0 0 .5.5h8.668a.507.507 0 0 0 .5-.5V2.18zM3.355 1a.5.5 0 0 0-.298.104l4.63 3.283 4.63-3.284A.5.5 0 0 0 12.021 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.197 11.256h8.913a1.19 1.19 0 0 0 1.13-.735c.062-.147.093-.305.093-.465v-.8h-.824v.8a.406.406 0 0 1-.399.4H1.197a.404.404 0 0 1-.4-.4V3.123a.406.406 0 0 1 .4-.4H2v-.8h-.803A1.195 1.195 0 0 0 0 3.123v6.933a1.2 1.2 0 0 0 1.197 1.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailCopy);
export default ForwardRef;